import React from 'react';
import { OrderStatus } from '../../../types';
import './OrderStatusBadge.css';

interface OrderStatusBadgeProps {
  status: OrderStatus;
  className?: string;
}

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusConfig = (status: OrderStatus) => {
    switch (status) {
      case 'pending':
        return { label: 'Pending', variant: 'warning' as const };
      case 'confirmed':
        return { label: 'Confirmed', variant: 'info' as const };
      case 'processing':
        return { label: 'Processing', variant: 'processing' as const };
      case 'ready_for_collection':
        return { label: 'Ready for Collection', variant: 'success' as const };
      case 'out_for_delivery':
        return { label: 'Out for Delivery', variant: 'info' as const };
      case 'delivered':
        return { label: 'Delivered', variant: 'success' as const };
      case 'completed':
        return { label: 'Completed', variant: 'success' as const };
      case 'cancelled':
        return { label: 'Cancelled', variant: 'danger' as const };
      case 'refunded':
        return { label: 'Refunded', variant: 'danger' as const };
      default:
        return { label: 'Unknown', variant: 'neutral' as const };
    }
  };

  const { label, variant } = getStatusConfig(status);

  return (
    <span className={`order-status-badge ${variant} ${className}`}>
      {label}
    </span>
  );
};

export default OrderStatusBadge;
